import SelectSearch from "./SelectSearch";

export default SelectSearch;
